export default "__VITE_ASSET__B5RwC30h__"